<form [formGroup]="credit_reporting_form">
    <div class="input-cell">
        <div class="price-pill">
            Build your Credit Score for <strong>{{ monthlyCreditReportingAmount | currency:'USD':'symbol':'1.2-2' }}/month</strong>
        </div>
        <div><strong>{{header_text}}</strong></div>
        <div class="d-flex align-items-center justify-content-center">
            <span class="mr-2" [style.font-weight]="!credit_reporting_model.credit_reporting.credit_reporting_enabled ? 'bold' : 'normal'">No</span>
            <mat-slide-toggle color="primary" (change)="creditReportingToggled()"
                [checked]="credit_reporting_model.credit_reporting.credit_reporting_enabled">
            </mat-slide-toggle>
            <span class="ml-2" [style.font-weight]="credit_reporting_model.credit_reporting.credit_reporting_enabled ? 'bold' : 'normal'">Yes</span>
        </div>
    </div>
</form>
<form *ngIf="credit_reporting_model.credit_reporting.credit_reporting_enabled"
    [formGroup]="credit_reporting_enabled_form" class="mt-4">
    <div class="row mb-2">
        <div class="col-12 text-center">
            <label *ngIf="!birthDateErrorMessage" class="section-label">Birth Date</label>
            <mat-error *ngIf="birthDateErrorMessage" class="pb-2">
                {{birthDateErrorMessage}}
            </mat-error>
        </div>
        <div class="col-12">
            <div class="d-flex justify-content-center">
                <nexus-form-date-input formControlName="birth_date" (invalidDateChange)="onBirthDateInvalidChange($event)" class="date-input-container" label="DOB"></nexus-form-date-input>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12 text-center">
            <label *ngIf="!legalNameErrorMessage" class="section-label">Legal Name</label>
            <mat-error *ngIf="legalNameErrorMessage" class="pb-2">
                {{legalNameErrorMessage}}
            </mat-error>
        </div>
        <div class="col-12">
            <div class="row legal-name-inputs-container">
                <div class=" input-cell col-sm-4"> <mat-form-field><mat-label>First Name</mat-label><input matInput type="text" formControlName="legal_first_name" class="text-center" /></mat-form-field>
                </div>
                <div class=" input-cell col-sm-4"><mat-form-field><mat-label>Middle Name</mat-label><input matInput type="text" formControlName="legal_middle_name" class="text-center" /></mat-form-field>
                </div>
                <div class="input-cell  col-sm-4"> <mat-form-field><mat-label>Last Name</mat-label><input matInput type="text" formControlName="legal_last_name" class="text-center" /></mat-form-field></div>
            </div>
        </div>
    </div>
</form>
